import store from "store2";
import { jsPsych } from "../../taskSetup";

export const updateProgressBar = () => {
  let currentValue = jsPsych.getProgressBarCompleted();
  jsPsych.setProgressBar(currentValue + 1 / store.session.get("totalNumItems"));
};
